export default {
  namespaced: true,
  state: {
    roles: [],
    scopes: {},
    localeCode: null,
    isLoadLanguage: false,
    systemClasses: [],
    systemSubclasses: [],
  },
  mutations: {
    SET_SCOPES(state, data) {
      state.scopes = data;
    },
    SET_ROLES(state, data) {
      state.roles = data;
    },
    SET_LOCALE_CODE(state, data) {
      state.localeCode = data;
    },
    LOAD_PACKAGE_LANGUAGE(state) {
      state.isLoadLanguage = true;
    },
    SET_SYSTEM_CLASSES(state, data) {
      state.systemClasses = data;
    },
    SET_SYSTEM_SUBCLASSES(state, data) {
      state.systemSubclasses = data;
    },
  },
  actions: {
    setScopes({ commit }, data) {
      commit('SET_SCOPES', data);
    },
    setRoles({ commit }, data) {
      commit('SET_ROLES', data);
    },
    setLocaleCode({ commit }, data) {
      commit('SET_LOCALE_CODE', data);
    },
    loadPackageLanguage({ commit }) {
      commit('LOAD_PACKAGE_LANGUAGE');
    },
    setSystemClasses({ commit }, data) {
      commit('SET_SYSTEM_CLASSES', data);
    },
    setSystemSubclasses({ commit }, data) {
      commit('SET_SYSTEM_SUBCLASSES', data);
    },
  },
};
